import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  BlacklistParams,
  BlackFindByPageParams,
  DetailParams,
  BlackFindByPageBackData
} from '@/typings/api/overseasSales'

/**
 * ************************************** 黑名单 **************************************
 */
// 新增黑名单
export function blacklist(data?: BlacklistParams) {
  return request.post<AxiosResult>('/ofbu/api/blacklist', data)
}
// 分页查询黑名单信息
export function blackFindByPage(data?: BlackFindByPageParams) {
  return request.post<AxiosResult>('/ofbu/api/blacklist/findByPage', data)
}
// 获取黑名单详情
export function detailData(params?: DetailParams) {
  return request.get<AxiosResult>('/ofbu/api/blacklist', { params })
}
// 修改黑名单
export function editData(data: BlackFindByPageBackData) {
  return request.post<AxiosResult>('/ofbu/api/blacklist/update', data)
}
// 移除黑名单
export function deleteData(params: DetailParams) {
  return request.delete<AxiosResult>(`/ofbu/api/blacklist/${params}`)
}
export function getCustomerPage(data?: any) {
  return request.post<AxiosResult>('/ofbu/api/customer/name/getCustomerPage', data)
}
